let data = {};

if (!sessionStorage.getItem('retireData')) {
  data = {
    gender: 'female',
    job: 'labor',
    age: 0,
    retireAge: 65,
    retireMoney: 31375,
    retireProperty: 0,
    rental: 0,
    perMonthSpend: 31338,
    lifeModel: 'simple',
    q1: [],
    q2: '',
    q3: '',
  };
} else {
  data = JSON.parse(sessionStorage.getItem('retireData'));
}

const lifeModel = {
  simple: {
    title: '簡單生活',
    content: '一般大眾運輸、小吃店家、國內旅遊、診所醫療',
  },
  carefree: {
    title: '自在悠活',
    content: '自駕出行、中階餐館、每年海外短/長程旅行、不定期聘僱到宅照護服務',
  },
  elegant: {
    title: '優雅樂活',
    content: '專車接送代步、高級料理、每季嚴選海外長程旅行、專人看護',
  }
};

const resultTypeDesc = [
  '下列方案提供您參考！',
  '下列方案也很適合您！',
];

const resultText = [
  '瞄準退休金缺口目標全力以赴，迎向無後顧之憂的退休生活',
  '距離退休目標尚有一哩路，迎向安穩精彩的退休生活',
  '穩定滾大退休金，迎向富足豐裕的退休生活'
];

let rate = 2;

const statusType = [
  'financial',
  'alone',
  'scam',
  'inherit',
];

const plans = {
  high: {
    title: '即刻守護安養信託',
    desc: '讓此後的您，安享晚年',
    content: '由永豐銀行立即啟動資產管理、運用，<br>以保障生活、照護、醫療給付需求',
    bg: 'bg-protect',
  },
  medium: {
    title: '預約幸福<br>安養樂活信託',
    desc: '用現在的財富，預先規劃未來的照顧',
    content: '提前安排財產運用方式<br>信託專注照顧自己，自主安心面對老後',
    bg: 'bg-care-trust',
  },
  low: {
    title: '預約幸福<br>安養樂活信託',
    desc: '用現在的財富，預先規劃未來的照顧',
    content: '提前安排財產運用方式<br>信託專注照顧自己，自主安心面對老後',
    bg: 'bg-care-trust',
  },
};

const inheritPlans = [
  {
    title: '遺囑信託',
    desc: '遺產更具保障，更有溫度',
    content: '遺產交由永豐銀行專業管理，<br>可事先約定受益人領取信託財產的時程及條件',
    bg: 'bg-will',
  },
  {
    title: '公益信託',
    desc: '行善舉，讓有意義的回饋行動持續',
    content: '您的愛心結合信託，<br>創造更多促進社會公益機會',
    bg: 'bg-public-welfare',
  }
];

window.addEventListener('DOMContentLoaded', function () {
  const assessmentPage = document.querySelector('.l-assessment');
  const retiredPage = document.querySelector('.l-retirement-life');
  const nonFinancialPage = document.querySelector('.l-non-financial');
  const reportPage = document.querySelector('.l-report-page');

  if (assessmentPage) {
    const age = document.getElementById('age');
    const retireMoney = document.getElementById('retire-money');
    const retireProperty = document.getElementById('retire-property');
    const rental = document.getElementById('rental');
    const ageInvalidTextEl = document.querySelector('.retire-age-invalid-feedback');
    const moneyInvalidTextEl = document.querySelector('.retire-money-invalid-feedback');

    prepareData('age', age);
    prepareData('retireMoney', retireMoney);
    prepareData('retireProperty', retireProperty);
    prepareData('rental', rental);

    const bsTab = new bootstrap.Tab(`button[data-bs-toggle="tab"][data-value=${data.gender}]`);
    bsTab.show();
    roleSwiper(data.gender);
    prepareRetireMoney();

    const tabs = document.querySelectorAll('button[data-bs-toggle="tab"]');
    tabs.forEach((tab) => {
      tab.addEventListener('shown.bs.tab', function (event) {
        const target = event.currentTarget;
        const prevTarget = event.relatedTarget;

        document.querySelector(`.j-assessment-swiper-${prevTarget.dataset.value}`).swiper?.destroy();

        data.gender = target.dataset.value;

        roleSwiper(data.gender);

        prepareRetireMoney();
      });
    });

    age?.addEventListener('input', function (event) {
      const target = event.currentTarget;

      data.age = parseInt(target.value);

      if (age.value < 0) {
        setTimeout(() => {
          age.value = '';
        }, 100)
      }

      if (age.value !== '' && validateAge(age.value)) {
        if (ageInvalidTextEl.classList.contains('d-none')) {
          ageInvalidTextEl.classList.remove('d-none');
        }
      } else {
        ageInvalidTextEl.classList.add('d-none');
      }
    });

    retireMoney?.addEventListener('input', function (event) {
      const target = event.currentTarget;

      data.retireMoney = parseInt(target.value);

      if (retireMoney.value > 100000) {
        if (moneyInvalidTextEl.classList.contains('d-none')) {
          moneyInvalidTextEl.classList.remove('d-none');
        }
      } else {
        moneyInvalidTextEl.classList.add('d-none');
      }
    });

    setData('retireProperty', retireProperty);
    setData('rental', rental);
  }

  if (retiredPage) {
    const slides = document.querySelectorAll('.swiper-slide');
    let initialIndex = 0;
    let isGet = false;

    slides.forEach((slide, index) => {
      if (slide.dataset.model === data.lifeModel && !isGet) {
        initialIndex = index;

        isGet = true;
      }
    });

    new Swiper('.j-tv-swiper', {
      initialSlide: initialIndex,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
      on: {
        slideChangeTransitionEnd: function (swiper) {
          data.perMonthSpend = parseInt(swiper.slides[swiper.activeIndex].dataset.value);

          data.lifeModel = swiper.slides[swiper.activeIndex].dataset.model;

          sessionStorage.setItem('retireData', JSON.stringify(data));
        }
      }
    });

    sessionStorage.setItem('retireData', JSON.stringify(data));
  }

  if (nonFinancialPage) {
    const qOne = document.querySelectorAll('[name=\'q1\']');
    const qTwo = document.querySelectorAll('[name=\'q2\']');
    const qThree = document.querySelectorAll('[name=\'q3\']');

    qOne.forEach((item) => {
      item.addEventListener('change', (event) => {
        const qOneChecked = document.querySelectorAll('[name=\'q1\']:checked');
        const qOneValue = [];

        if (qOneChecked.length <= 0) {
          qOne.forEach((el) => {
            el.setAttribute('required', '');
          });
        } else {
          qOne.forEach((el) => {
            el.removeAttribute('required');
          });
        }

        qOneChecked.forEach((checked) => {
          qOneValue.push(checked.value);
        });

        data.q1 = qOneValue;

        sessionStorage.setItem('retireData', JSON.stringify(data));
      });

      if (data.q1.length > 0) {
        if (data.q1.includes(item.value)) {
          item.setAttribute('checked', 'checked');
        }
      }
    });

    qTwo.forEach((item) => {
      item.addEventListener('change', (event) => {
        data.q2 = event.currentTarget.value;

        sessionStorage.setItem('retireData', JSON.stringify(data));
      });

      if (data.q2.includes(item.value)) {
        item.setAttribute('checked', 'checked');
      }
    });

    qThree.forEach((item) => {
      item.addEventListener('change', (event) => {
        data.q3 = event.currentTarget.value;

        sessionStorage.setItem('retireData', JSON.stringify(data));
      });

      if (data.q3.includes(item.value)) {
        item.setAttribute('checked', 'checked');
      }
    });
  }

  if (reportPage) {
    new Swiper('.imgSwiper', {
      direction: 'vertical',
      autoplay: true,
      loop: true,
    });

    const params = new URLSearchParams(window.location.search);
    const obj = {};

    if (params.has('result')) {
      const shareResult = window.atob(params.get('result'));

      for (const [key, value] of (new URLSearchParams(shareResult))) {
        if (obj.hasOwnProperty(key)) {
          if (!Array.isArray(obj[key])) {
            obj[key] = [obj[key]];
          }
          obj[key].push(value);
        } else {
          obj[key] = value;
        }
      }

      if (Object.keys(obj).length > 0) {
        data = obj;
      }
    }

    document.querySelector('.j-gender').textContent = data.gender === 'female' ? '女性' : '男性';
    document.querySelector('.j-age').textContent = data.age;
    document.querySelector('.j-model').textContent = lifeModel[data.lifeModel]?.title;
    document.querySelector('.j-model-content').textContent = lifeModel[data.lifeModel]?.content;
    document.querySelector('.j-per-month-spend').textContent = new Intl.NumberFormat().format(data.perMonthSpend);
    document.querySelector('.j-life-total').textContent = new Intl.NumberFormat().format(prepareRetireTotal());
    document.querySelector('.j-property').textContent = new Intl.NumberFormat().format(prepareRetireProperty());
    document.querySelector('.j-gap-type').textContent = prepareRetireGapType() ? '缺口' : '盈餘';
    document.querySelector('.j-gap').textContent = new Intl.NumberFormat().format(prepareRetireGap());
    document.querySelector('.j-gap').style.color = prepareResultColor();
    document.querySelector('.j-progress').textContent = prepareProgress();
    document.querySelector('.j-progress').style.color = prepareProgressColor();
    document.querySelector('.j-progress-circle').setAttribute(
      'stroke-dashoffset',
      100 * 3.1415926 / 360 * (360 - 360 * prepareProgress() / 100)
    );
    document.querySelector('.j-progress-circle').style.stroke = prepareRetireGapType() ? '#635647' : '#4cb068';
    document.querySelector('.j-result-type').textContent = prepareResultType();
    document.querySelector('.j-result-type').style.color = prepareResultColor();
    document.querySelector('.l-report-page .c-chart-content #chart').style.backgroundColor = prepareResultBgColor();
    document.querySelector('.j-result-type-desc').textContent = prepareRetireGapType() ? resultTypeDesc[0] : resultTypeDesc[1];
    document.querySelector('.j-result-text').textContent = prepareResultText();
    document.querySelector('.j-rate').textContent = rate;

    if (!prepareRetireGapType()) {
      document.querySelector('.c-chart-amount').style.display = 'none';
    }

    const result = pmt(rate / 100 / 12, (data.retireAge - data.age) * 12, 0, prepareRetireGap() * 10000, 0);

    if (!isNaN(result) && prepareRetireGapType()) {
      document.querySelector('.j-invest').value = Math.abs(result / 10000).toFixed(2);
    }

    const rateOptions = document.querySelectorAll('.j-rate-option');

    rateOptions.forEach((option) => {
      option.addEventListener('click', (event) => {
        const target = event.currentTarget;

        document.querySelector('.j-rate').textContent = target.dataset.value;
        rate = parseInt(target.dataset.value);

        const result = pmt(rate / 100 / 12, (data.retireAge - data.age) * 12, 0, prepareRetireGap() * 10000, 0);

        if (!isNaN(result) && prepareRetireGapType()) {
          document.querySelector('.j-invest').value = Math.abs(result / 10000).toFixed(2);
        }
      });
    });

    statusType.forEach((type) => {
      let status = '';
      let color = '#ff6868';
      let risk = 'high';
      let score = 0;

      if (type === 'scam') {
        if (data.q1.includes('experienced')) {
          score += 4;
        }

        if (data.q1.includes('unfamiliar')) {
          score += 3;
        }

        if (data.q1.includes('contacted')) {
          score += 2;
        }

        if (data.q1.includes('uncontacted')) {
          score += 1;
        }
      }

      if (type === 'alone') {
        switch (data.q2) {
          case 'alone':
            score = 4;
            break;
          case 'caregiver':
            score = 3;
            break;
          case 'one_together':
            score = 2;
            break;
          case 'all_together':
            score = 1;
            break;
        }
      }

      if (type === 'inherit') {
        switch (data.q3) {
          case 'unclear':
            score = 3;
            break;
          case 'progress':
            score = 2;
            break;
          case 'completed':
            score = 1;
            break;
        }
      }

      if (type === 'financial') {
        if (prepareProgress() < 50) {
          risk = 'high';
        }

        if (prepareProgress() >= 50 && prepareProgress() <= 80) {
          risk = 'medium';
        }

        if (prepareProgress() > 80) {
          risk = 'low';
        }
      } else {
        if (score <= 1) {
          risk = 'low';
        }

        if (score === 2) {
          risk = 'medium';
        }

        if (score >= 3) {
          risk = 'high';
        }
      }

      switch (risk) {
        case 'high':
          status = '<img src="./assets/images/front/report/high.svg" alt="高風險：需立即行動"> 高風險：需立即行動';
          color = '#ff6868';
          break;
        case 'medium':
          status = '<img src="./assets/images/front/report/medium.svg" alt="中風險：可預約諮詢"> 中風險：可預約諮詢';
          color = '#e49349';
          break;
        case 'low':
          status = '<img src="./assets/images/front/report/low.svg" alt="低風險：可暫免行動"> 低風險：可暫免行動';
          color = '#76c97d';
          break;
      }

      document.querySelectorAll('.j-status-' + type).forEach((item) => {
        item.innerHTML = status;
        item.style.backgroundColor = color;
      });

      const fields = ['title', 'desc', 'content', 'link', 'bg'];

      if (['alone', 'scam'].includes(type)) {
        fields.forEach((field) => {
          document.querySelectorAll('.j-' + field + '-' + type + '-main').forEach((item) => {
            if (field === 'link') {
              item.setAttribute('href', 'https://trust.sinopac.com/ETrust/Web/Home/Contact');
              item.setAttribute('target', '_blank');
            } else if (field === 'bg') {
              item.classList.add(plans[risk][field]);
            } else {
              item.innerHTML = plans[risk][field];
            }

            if (field === 'title') {
              item.style.minWidth = '211px';
              item.style.textAlign = 'center';
            }
          });

          document.querySelectorAll('.j-' + field + '-' + type).forEach((item, index) => {
            if (field === 'link') {
              item.setAttribute('href', 'https://trust.sinopac.com/ETrust/Web/Home/Contact');
              item.setAttribute('target', '_blank');
            }

            if (field === 'title') {
              item.style.minWidth = '211px';
              item.style.textAlign = 'center';
            }

            if (index === 0) {
              let done = false;

              Object.keys(plans).forEach((key) => {
                if (key !== risk && !done) {
                  if (field !== 'link') {
                    if (field === 'bg') {
                      item.classList.add(plans[key][field]);
                    } else {
                      item.innerHTML = plans[key][field];
                    }
                  }

                  done = true;
                }
              });
            }

            if (index === 1) {
              if (field === 'title') {
                item.innerHTML = '保險金信託';
              }

              if (field === 'desc') {
                item.innerHTML = '擁有信託保障，妥善運用保險金';
              }

              if (field === 'content') {
                item.innerHTML = '保險金信託能夠確保保險金按照<br>您的意願使用，避免保險金遭挪用或浪費';
              }

              if (field === 'bg') {
                item.classList.add('bg-insurance');
              }
            }
          });
        });
      }

      if (type === 'inherit') {
        fields.forEach((field) => {
          document.querySelectorAll('.j-' + field + '-inherit-main').forEach((item) => {
            if (field === 'link') {
              item.setAttribute('href', 'https://trust.sinopac.com/ETrust/Web/Home/Contact');
              item.setAttribute('target', '_blank');
            }

            if (field === 'title') {
              item.innerHTML = '家族信託';
              item.style.minWidth = '211px';
              item.style.textAlign = 'center';
            }

            if (field === 'desc') {
              item.innerHTML = '傳承財富，守護家族首選';
            }

            if (field === 'content') {
              item.innerHTML = '靈活規劃家族接班安排，<br>協助稅務規劃、資產管理、企業永續經營';
            }

            if (field === 'bg') {
              item.classList.add('bg-family');
            }
          });

          document.querySelectorAll('.j-' + field + '-inherit').forEach((item, index) => {
            if (field === 'link') {
              item.setAttribute('href', 'https://trust.sinopac.com/ETrust/Web/Home/Contact');
              item.setAttribute('target', '_blank');
            } else if (field === 'bg') {
              item.classList.add(inheritPlans[index][field]);
            } else {
              item.innerHTML = inheritPlans[index][field];
            }

            if (field === 'title') {
              item.style.minWidth = '211px';
              item.style.textAlign = 'center';
            }
          });
        });
      }
    });

    document.querySelectorAll('.j-model-img').forEach((img, index) => {
      img.setAttribute('src', './assets/images/front/report/' + data.lifeModel + (index + 1) + '.png');
    });

    document.querySelector('.j-reset-btn').addEventListener('click', (event) => {
      sessionStorage.removeItem('retireData');

      location.href = './assessment.html';
    });

    const queryString = toQueryString(JSON.parse(sessionStorage.getItem('retireData')));

    document.querySelector('.j-line-share').setAttribute(
      'href',
      'https://social-plugins.line.me/lineit/share?url=https://demo.lyrasoft.net/sinopac-trust/report.html?result=' + window.btoa(queryString)
    )
  }

  // validation
  (function () {
    'use strict';

    const form = document.querySelector('.needs-validation');

    if (!form) {
      return;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();

      let failed = false;

      if (nonFinancialPage) {
        const qOne = document.querySelectorAll('[name=\'q1\']');
        const qOneChecked = document.querySelector('[name=\'q1\']:checked');

        if (qOneChecked === null) {
          qOne.forEach((el) => {
            el.setAttribute('required', '');
          });

          failed = true;
        } else {
          qOne.forEach((el) => {
            el.removeAttribute('required');
          });
        }
      }

      if (!form.checkValidity()) {
        failed = true;
      }

      if (!failed) {
        if (assessmentPage) {

          if (validateAge(data.age)) {
            document.querySelector('.retire-age-invalid-feedback')?.classList.remove('d-none');

            clearAge();
          } else if (data.retireMoney > 100000) {
            document.querySelector('.retire-money-invalid-feedback')?.classList.remove('d-none');

            document.getElementById('retire-money').value = '';

            prepareRetireMoney();
          } else {
            document.querySelector('.retire-age-invalid-feedback')?.classList.add('d-none');

            sessionStorage.setItem('retireData', JSON.stringify(data));

            location.href = './retirement-life.html';
          }
        }

        if (retiredPage) {
          location.href = './non-financial.html';
        }

        if (nonFinancialPage) {
          location.href = './report.html';
        }
      }

      const elementPosition = document.querySelector('input:invalid').getBoundingClientRect().top - document.body.getBoundingClientRect().top;
      const offsetPosition = elementPosition - 150;

      window.scrollTo(
        {
          top: offsetPosition,
          behavior: 'smooth'
        }
      );

      form.classList.add('was-validated');
    }, false);
  })();
});

// assessment page swiper
function roleSwiper(gender) {
  const slides = document.querySelectorAll('.swiper-slide');
  let initialIndex = 0;
  let isGet = false;

  slides.forEach((slide, index) => {
    if (slide.dataset.value === data.job && !isGet) {
      initialIndex = index;

      isGet = true;
    }
  });

  new Swiper(`.j-assessment-swiper-${gender}`, {
    initialSlide: initialIndex,
    slidesPerView: 2,
    spaceBetween: 24,
    loop: true,
    centeredSlides: true,
    slideToClickedSlide: true,
    allowTouchMove: true,
    navigation: {
      nextEl: `.swiper-button-next-${gender}`,
      prevEl: `.swiper-button-prev-${gender}`,
    },
    breakpoints: {
      1400: {
        slidesPerView: 4,
      },
      1920: {
        slidesPerView: 5,
      },
    },
    on: {
      slideChangeTransitionEnd: function (swiper) {
        data.job = swiper.slides[swiper.activeIndex]?.dataset?.value;

        prepareRetireMoney();

        sessionStorage.setItem('retireData', JSON.stringify(data));
      }
    }
  });
}

// bottom progressBar
const progressBar = document.querySelector('.j-progress-bar');
const reserveBtn = document.querySelector('.j-reserve-btn');
const footerBottom = document.querySelector('.j-footer');

window.onscroll = () => {

  if (window.scrollY > 350) {
    progressBar.classList.add('active');
    reserveBtn.classList.add('moved');
    footerBottom.classList.add('moved');
  } else {
    progressBar.classList.remove('active');
    reserveBtn.classList.remove('moved');
    footerBottom.classList.remove('moved');
  }

  const kanban1 = document.getElementById('risk1');
  const kanbanNav = document.querySelector('.j-risk-nav');

  if (!kanban1) {
    return;
  }

  const windowHeight = window.innerHeight;
  const elementTop = kanban1.getBoundingClientRect().top;

  if (elementTop <= windowHeight / 2) {
    kanbanNav.classList.add('show');
  } else {
    kanbanNav.classList.remove('show');
  }
};

function prepareData(field, input) {
  if (data[field] !== 0) {
    input.value = data[field];
  }
}

function setData(field, input) {
  input?.addEventListener('input', function (event) {
    const target = event.currentTarget;

    data[field] = parseInt(target.value);
  });
}

function prepareRetireMoney() {
  const retireMoney = document.getElementById('retire-money');

  switch (data.job) {
    case 'labor':
      data.retireMoney = 31375;
      break;
    case 'soldier':
      data.retireMoney = 56706;
      break;
    case 'public-teacher':
      data.retireMoney = 49434;
      break;
    case 'private-teacher':
      data.retireMoney = 43090;
      break;
    case 'other':
      data.retireMoney = 10276;
      break;
  }

  retireMoney.value = data.retireMoney;
}

function validateAge(age) {
  return age >= 65 || age < 30;
}

function clearAge() {
  data.age = 0;

  document.getElementById('age').value = '';
}

function prepareRetireLife() {
  let life = 0;

  if (data.gender === 'female') {
    life = 83;
  }

  if (data.gender === 'male') {
    life = 78;
  }

  const retireLife = life - data.retireAge;

  if (retireLife <= 0) {
    return 0;
  }

  return retireLife;
}

function prepareRetireTotal() {
  return Math.round(prepareRetireLife() * 12 * parseInt(data.perMonthSpend) / 10000);
}

function prepareRetireProperty() {
  return Math.round((parseInt(data.retireMoney) + (parseInt(data.rental) * 10000)) * 12 * prepareRetireLife() / 10000) + parseInt(data.retireProperty);
}

function prepareRetireGapType() {
  return prepareRetireTotal() - prepareRetireProperty() > 0;
}

function prepareRetireGap() {
  if (prepareRetireGapType()) {
    return prepareRetireTotal() - prepareRetireProperty();
  } else {
    return prepareRetireProperty() - prepareRetireTotal();
  }
}

function prepareProgress() {
  if (prepareRetireGapType()) {
    return Math.round(prepareRetireProperty() / prepareRetireTotal() * 100);
  } else {
    return 100;
  }
}

function prepareResultText() {
  const result = prepareProgress();

  if (result < 50) {
    return resultText[0];
  }

  if (result >= 50 && result < 80) {
    return resultText[1];
  }

  if (result > 80) {
    return resultText[2];
  }
}

function pmt(ir, np, pv, fv, type) {
  let pmt;
  let pvif;

  fv || (fv = 0);
  type || (type = 0);

  if (ir === 0) {
    return floorToDecimalFirst(-(pv + fv) / np);
  }

  pvif = Math.pow(1 + ir, np);
  pmt = -ir * (pv * pvif + fv) / (pvif - 1);

  if (type === 1) {
    pmt /= (1 + ir);
  }

  return floorToDecimalFirst(pmt);
}

function floorToDecimalFirst(number) {
  return Math.floor(parseFloat(number) * 10) / 10;
}

function prepareResultBgColor() {
  if (!prepareRetireGapType()) {
    return '#76c97d';
  }

  if (prepareRetireGap() === 0) {
    return '#e49349';
  }

  if (prepareProgress() < 80) {
    return '#ff6868';
  }

  if (prepareProgress() >= 80) {
    return '#e49349';
  }

  return '#76c97d';
}

function prepareResultColor() {
  if (!prepareRetireGapType()) {
    return '#76c97d';
  }

  if (prepareRetireGap() === 0) {
    return '#e49349';
  }

  if (prepareProgress() < 80) {
    return '#ff6868';
  }

  if (prepareProgress() >= 80) {
    return '#e49349';
  }

  return '#76c97d';
}

function prepareProgressColor() {
  if (!prepareRetireGapType()) {
    return '#76c97d';
  }

  if (prepareRetireGap() === 0) {
    return '#e49349';
  }

  return '#635647';
}

function prepareResultType() {
  if (!prepareRetireGapType()) {
    return '已達成退休準備進度!';
  }

  if (prepareRetireGap() === 0) {
    return '已達成退休準備進度!';
  }

  if (prepareProgress() < 80) {
    return '您尚未達成退休準備進度';
  }

  if (prepareProgress() >= 80) {
    return '即將達成退休準備進度!';
  }

  return '';
}

function toQueryString(v) {
  const parts = [];

  for (const [key, value] of Object.entries(v)) {
    if (Array.isArray(value)) {
      value.forEach(val => parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`));
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }

  return parts.join('&');
}
